import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const match = (a, b) => {
  const valA = a == null ? "" : String(a).trim();
  const valB = b == null ? "" : String(b).trim();

  if (!valA && !valB) return true;
  if (!valA || !valB) return false;

  return valA === valB;
};

const renderInputMatchAdornment = (isEditing, cin7Val, shopifyVal) => {
  if (isEditing) {
    const isMatch = match(cin7Val, shopifyVal);

    return {
      endAdornment: isMatch ? (
        <CheckIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    };
  }
  return null;
};

export default renderInputMatchAdornment;
